var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticStyle:{"font-family":"'微软雅黑'"}},[(
      _vm.$vuetify.breakpoint.name != 'xs' ||
      _vm.$route.path == '/Register_mobile' ||
      _vm.$route.path == '/MobilePublicity' ||
      _vm.$route.path == '/PrivacyPolicy_mobile' ||
      _vm.$route.path == '/ServiceAgreement_mobile'||
      _vm.$route.path == '/CountyPrices'||
      _vm.$route.path == '/Login_mobile'
    )?_c('v-content',[(
        !(_vm.hideTopNaviUrls.indexOf(_vm.$route.path) > -1) &&
        !/\/Archive/.test(_vm.$route.path) && _vm.$route.path != '/viewMapSource'
      )?_c('home-navi',{staticClass:"mediaShow",staticStyle:{"z-index":"999"}}):_vm._e(),(_vm.isRouterAlive)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e(),(
        _vm.$route.path == '/' ||
        _vm.$route.path == '/GeneralTraffic/Home' ||
        _vm.$route.path == '/AnnualPurchase/Home' ||
        _vm.$route.path == '/rsManage' ||
        _vm.$route.path == '/process' ||
        _vm.$route.path == '/Payment' ||
        _vm.$route.path == '/Contract' ||
        _vm.$route.path == '/MyRSservice' ||
        _vm.$route.path == '/RSsserviceManage'||
        _vm.$route.path == '/Instruction'||
        _vm.$route.path == '/MyRSservices'||
        _vm.$route.path == '/Feedback'||
        _vm.$route.path == '/ProcessRep'||
        _vm.$route.path == '/CountyPrices'
      )?_c('home-footer'):_vm._e(),(!(_vm.hideOnlineServiceUrls.indexOf(_vm.$route.path) > -1))?_c('onlineService'):_vm._e()],1):_vm._e(),(
      _vm.$vuetify.breakpoint.name == 'xs' &&
      _vm.$route.path != '/Register_mobile' &&
      _vm.$route.path != '/PrivacyPolicy_mobile' &&
      _vm.$route.path != '/ServiceAgreement_mobile'&&
      _vm.$route.path != '/MobilePublicity'&&
      _vm.$route.path != '/CountyPrices'&&
      _vm.$route.path != '/Login_mobile'
    )?_c('NoMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }